import { render, staticRenderFns } from "./ReportByPerson.vue?vue&type=template&id=28ecf1da&scoped=true&"
import script from "./ReportByPerson.vue?vue&type=script&lang=js&"
export * from "./ReportByPerson.vue?vue&type=script&lang=js&"
import style0 from "./ReportByPerson.vue?vue&type=style&index=0&id=28ecf1da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ecf1da",
  null
  
)

export default component.exports